export const renderDefaultValueCols = (value: any) => {
  // null / undefined
  if (value === null || value === undefined) {
    return '-';
  }

  // arrays
  if (Array.isArray(value)) {
    return value.length > 0 ? value : '-';
  }

  // numbers
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  // strings
  if (typeof value === 'string') {
    return value.trim() ? value : '-';
  }

  return value;
};
